<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg" [token]="token">

  <ng-container *ngIf="consulta">
    <div class="table-responsive">
      <table *ngIf="consulta?.lista.length>0" class="table table-striped table-sm">
        <tr class="text-primary text-center">
          <th>CGC CPF</th>
          <th>Chassi</th>
          <th>Placa</th>
          <th>Renavam</th>
        </tr>
        <tr *ngFor="let v of consulta?.lista" class="text-center">
          <td>{{v?.cgcCpf || 'NÃO INFORMADO'}}</td>
          <td>{{v?.chassi || 'NÃO INFORMADO'}}</td>
          <td>{{v?.placa || 'NÃO INFORMADO'}}</td>
          <td>{{v?.renavam || 'NÃO INFORMADO'}}</td>
        </tr>
      </table>
    </div>
  </ng-container>
